import * as React from "react";
function SvgSwap(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 18a5 5 0 005-5v-1h-2v1a3 3 0 01-3 3H7.414l1.293-1.293.707-.707L8 12.586l-.707.707-3 3a1 1 0 000 1.414l3 3 .707.707L9.414 20l-.707-.707L7.414 18H15zm4.707-10.293a1 1 0 000-1.414l-3-3L16 2.586 14.586 4l.707.707L16.586 6H9a5 5 0 00-5 5v1h2v-1a3 3 0 013-3h7.586l-1.293 1.293-.707.707L16 11.414l.707-.707 3-3z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgSwap);
export default ForwardRef;
